import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Layout from "../components/Layout";
import { Link } from "react-router-dom";

const NewsContainer = styled.div``;

const Section = styled.section`
  padding: 5rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
`;

const NewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const NewsCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }
`;

const NewsImage = styled.div`
  height: 200px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
  color: #0099cc;
`;

const NewsContent = styled.div`
  padding: 1.5rem;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: #333;
  }

  .date {
    font-size: 0.9rem;
    color: #999;
    margin-bottom: 1rem;
    display: block;
  }

  .category {
    display: inline-block;
    padding: 0.3rem 0.8rem;
    background-color: #0099cc;
    color: #fff;
    border-radius: 4px;
    font-size: 0.8rem;
    margin-bottom: 1rem;
  }

  p {
    color: #666;
    margin-bottom: 1rem;
    line-height: 1.6;
  }
`;

const ReadMoreButton = styled(Link)`
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: transparent;
  color: #0099cc;
  border: 1px solid #0099cc;
  border-radius: 4px;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background-color: #0099cc;
    color: #fff;
  }
`;

const Pagination = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
`;

const PageButton = styled.button`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5rem;
  border-radius: 50%;
  border: 1px solid #ddd;
  background-color: ${(props) => (props.active ? "#0099cc" : "transparent")};
  color: ${(props) => (props.active ? "#fff" : "#333")};
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${(props) => (props.active ? "#0099cc" : "#f5f5f5")};
  }
`;

const News = () => {
  // ニュース記事のダミーデータ
  const newsItems = [
    {
      id: 1,
      title: "新しい農業IoTデバイス「ファームテック Pro」を発表",
      date: "2025年5月15日",
      category: "プレスリリース",
      image: "🌱",
      excerpt:
        "当社は、最新の農業IoTデバイス「ファームテック Pro」を発表しました。AIを活用した高度な環境制御機能を搭載し、農作物の収穫量を最大30%向上させることが可能です。",
    },
    {
      id: 2,
      title: "テクノロイグ、大手IT企業と業務提携を締結",
      date: "2025年4月22日",
      category: "お知らせ",
      image: "🤝",
      excerpt:
        "当社は、大手IT企業との業務提携を締結しました。この提携により、クラウドサービスの拡充とAI技術の強化を図り、お客様により高品質なサービスを提供してまいります。",
    },
    {
      id: 3,
      title: "新卒採用情報を公開しました",
      date: "2025年4月1日",
      category: "採用情報",
      image: "👨‍💼",
      excerpt:
        "2026年度の新卒採用情報を公開しました。エンジニア職、営業職、企画職など多様な職種で募集を行っています。説明会は5月より順次開催予定です。",
    },
    {
      id: 4,
      title: "プログラミングスクール「テックアカデミー」開校",
      date: "2025年3月10日",
      category: "サービス",
      image: "💻",
      excerpt:
        "IT教育事業の一環として、プログラミングスクール「テックアカデミー」を開校しました。初心者から上級者まで、様々なレベルに対応したカリキュラムを提供しています。",
    },
    {
      id: 5,
      title: "本社オフィスを移転しました",
      date: "2025年2月15日",
      category: "お知らせ",
      image: "🏢",
      excerpt:
        "事業拡大に伴い、本社オフィスを移転しました。新オフィスは最新の設備を整え、より快適な職場環境を実現しています。",
    },
    {
      id: 6,
      title: "年間売上50億円を達成",
      date: "2025年1月30日",
      category: "プレスリリース",
      image: "📈",
      excerpt:
        "2024年度の年間売上が50億円を突破しました。これもひとえに、お客様からのご支援の賜物と心より感謝申し上げます。",
    },
  ];

  return (
    <Layout>
      <NewsContainer>
        <Header
          title="ニュース"
          subtitle="テクノロイグの最新情報をお届けします"
          showButton={false}
        />

        <Section>
          <SectionTitle>最新ニュース</SectionTitle>
          <NewsGrid>
            {newsItems.map((item) => (
              <NewsCard key={item.id}>
                <NewsImage>{item.image}</NewsImage>
                <NewsContent>
                  <span className="category">{item.category}</span>
                  <span className="date">{item.date}</span>
                  <h3>{item.title}</h3>
                  <p>{item.excerpt}</p>
                  <ReadMoreButton to={`/news/${item.id}`}>
                    続きを読む
                  </ReadMoreButton>
                </NewsContent>
              </NewsCard>
            ))}
          </NewsGrid>

          <Pagination>
            <PageButton active>1</PageButton>
            <PageButton>2</PageButton>
            <PageButton>3</PageButton>
            <PageButton>
              <span>&gt;</span>
            </PageButton>
          </Pagination>
        </Section>
      </NewsContainer>
    </Layout>
  );
};

export default News;
